import pptxgen from 'pptxgenjs'
import docmaLogo from "@/assets/docma-logo-white-red.svg"
import docmaBackground from "@/assets/docma-headslide-background.png"
import * as export_helper from './exportHelper'

class PPTXBuilderOrtReport {
    constructor(report_name){
        this.pptx = new pptxgen();
        this.pptx_name = 'Docma ORT Report Export';
        this.report_name = report_name;
        this.export_pages = {
            'Overview': {chart_elements:[], table_elements:[], stats_elements: []},
            //'Optimization_template': {chart_elements:[], table_elements:[], stats_elements: []},
        }
    }
    set_slide(){
        this.pptx.defineSlideMaster({
            title: "docma_slide",
            background: {color: "#FFFFFF"},
            objects: [
                {text: {text: "", options: {x: 0, y: 0, w: "100%", h: '15%', fill: '#000000'}}},
                {image: {x: 8.4, y: "3%", w: 1.4,h: 0.35, path: docmaLogo}},
                { text: { text: "CONFIDENTIAL", options: { x:'0%', y:'95%', w:'100%', h:'5%', align:'center', fill:'#000000', color:'#ffffff', fontSize: 12} } },
                { text: { text: new Date().toString().slice(4, 16), options: { x:'5%', y:'95%', w:'100%', h:'5%', align:'left', color:'#ffffff', fontSize: 8 } } }
            ],
            slideNumber: { x: "90%", y: "95%", color:'#ffffff' }
        })
        this.pptx.defineSlideMaster({
            title: "docma_subheader_slide",
            objects: [
                {image: {x: 0, y: 0, w:'100%' ,h:'100%', path: docmaBackground}},
                {image: {x: 8.4, y: "3%", w: 1.4,h: 0.35, path: docmaLogo}},
                {text: { text: "CONFIDENTIAL", options: { x:'0%', y:'95%', w:'100%', h:'5%', align:'center', fill:'#000000', color:'#ffffff', fontSize: 12} } }
            ]
        })
    }

    add_header_slide(){
        let slide = this.pptx.addSlide({masterName: "docma_subheader_slide"});
        slide.addText("Docma ORT Export",{x: '5%',y: '3%', w: "50%", h: 3, align: 'left', fontFace: 'Poppins', fontWeight: 'Bold', fontSize: 30, color: '#ffffff'});
        slide.addText(this.report_name,{x: '5%',y: '13%', w: "50%", h: 3, align: 'left', fontFace: 'Poppins', fontSize: 20, color: '#ffffff'});
    }

    add_element(element, page, type){
        if(page && type && element) {
            if(!this.export_pages[page]) {
                this.export_pages[page] = {chart_elements: [], table_elements: [], stats_elements: []};
            }
            if(type == 'chart') {
                this.export_pages[page]['chart_elements'].push(element);
            } else if(type == 'table') {
                this.export_pages[page]['table_elements'].push(element);
            } else if(type == 'stats') {
                this.export_pages[page]['stats_elements'].push(element);
            }
        }
    }

    build_overview_slide(){
        const tableComp = this.export_pages['Overview']['table_elements'][0];

        const slide = this.pptx.addSlide({masterName: "docma_slide"});
        const table_header_name = export_helper.build_table_header_name(tableComp.table_headers)
        const table_header_value = export_helper.build_table_header_value(tableComp.table_headers)
        const table_body = export_helper.build_table_body(tableComp.table_data, table_header_value, true);

        slide.addText("Overview",
            {
                x:0, y:'0.12',w:'75%',h:'10%',
                align: 'left', fontFace: 'Poppins', fontSize: 25, color:'#ffffff'
            }
        );
    
        slide.addTable([table_header_name],{x:0.05, y:1.5, w:9.9, h:0.2, fontFace: 'Poppins', fontSize: 5, fill:'black', color:'#ffffff', border:{pt: "1", color: '#000000'}});
        slide.addTable(table_body, {x:0.05, y:1.9 , w:9.9, autoPage:true, autoPageRepeatHeader:true, autoPageLineWeight:0.5, newSlideStartY: 1, fontFace: 'Poppins', fontSize: 5, border:{pt: "1", color: '#000000'}});

    }

    build_performance_slides(){

        for (let page in this.export_pages) {
            if (page === 'Overview') continue; // Skip the overview page as it's handled separately
            const slide = this.pptx.addSlide({masterName: "docma_slide"});

            slide.addText(page,
                {
                    x:0, y:'0.12',w:'75%',h:'10%',
                    align: 'left', fontFace: 'Poppins', fontSize: 25, color:'#ffffff'
                }
            );

            const chartComp = this.export_pages[page]['chart_elements'][0];
            
            if (chartComp) {
                slide.addImage({data: chartComp.chart_image, x: 1.5, y: 1.5, h: 3.2, w: 6.5});
            }
        }
    }

    build(){
        this.set_slide();
        this.add_header_slide();
        
        // Add overview slide sss
        this.build_overview_slide();

        // Add performance slides
        this.build_performance_slides();
    }

    save(){
        this.pptx.writeFile(this.pptx_name);
    }
}
export default PPTXBuilderOrtReport